//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  data: ({value}) => ({
    formData: {
      query: value,
    },
  }),
  watch: {
    value() {
      if (this.value !== this.formData.query) {
        this.formData.query = this.value;
      }
    },
  },
  mounted() {
    if (this.$refs.search) {
      this.$refs.search.$el.querySelector('input').focus();
    }
  },
  methods: {
    onSearch(data) {
      this.$emit('input', data.query);
    },
  },
};
